var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharemodel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6001",
    "data-name": "Rectangle 6001",
    width: 16,
    height: 16,
    fill: "#758522"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36621",
    "data-name": "Group 36621",
    transform: "translate(-3436 -13871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_684",
    "data-name": "Mask Group 684",
    transform: "translate(3436 13871)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55857",
    "data-name": "Path 55857",
    d: "M13,15.333a1.992,1.992,0,0,1-2-2,1.832,1.832,0,0,1,.017-.242,1.212,1.212,0,0,1,.05-.225l-4.7-2.733a2.2,2.2,0,0,1-.633.392,2,2,0,0,1-2.15-.442,2.012,2.012,0,0,1,0-2.833,2,2,0,0,1,2.15-.441,2.209,2.209,0,0,1,.633.391l4.7-2.733a1.229,1.229,0,0,1-.05-.225A1.822,1.822,0,0,1,11,4a2,2,0,0,1,3.417-1.417A1.929,1.929,0,0,1,15,4a2,2,0,0,1-2.733,1.859,2.182,2.182,0,0,1-.633-.392L6.933,8.2a1.225,1.225,0,0,1,.05.225,1.76,1.76,0,0,1,0,.483,1.209,1.209,0,0,1-.05.225l4.7,2.733a2.189,2.189,0,0,1,.633-.391A1.95,1.95,0,0,1,13,11.333a2,2,0,0,1,1.417,3.417A1.929,1.929,0,0,1,13,15.333Z",
    transform: "translate(-1 -0.667)",
    fill: "#758522"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharemodel);
export default __webpack_public_path__ + "static/media/Sharemodel.9476790452e3adbd7cc1a63315f88522.svg";
export { ForwardRef as ReactComponent };